import { EInspectionType, ISellCarForm, IStepperIntializer } from '@/types';
import {
    CalendarIconGreen,
    ContactIconGreen,
    KMIconGreen,
    LensGreenIcon,
    LocationIconGreen,
    MakeIconGreen,
    ModelIconGreen,
    otherInfoIcon,
} from '../../../public/Images';

const STEPPER_STEPS_FULL_DATA: IStepperIntializer[] = [
    {
        label: 'make',
        pathOneOnly: false,
        icon: MakeIconGreen,
    },
    {
        label: 'model',
        pathOneOnly: false,
        icon: ModelIconGreen,
    },
    {
        label: 'year',
        pathOneOnly: false,
        icon: CalendarIconGreen,
    },
    {
        label: 'kilometers',
        pathOneOnly: false,
        icon: KMIconGreen,
    },
    {
        label: 'otherinfo',
        pathOneOnly: false,
        icon: otherInfoIcon,
    },
    {
        label: 'region',
        pathOneOnly: true,
        icon: LocationIconGreen,
    },
    {
        label: 'contactInfo',
        pathOneOnly: false,
        icon: ContactIconGreen,
    },
];

const SELL_CAR_FORM_DATA_FULL: ISellCarForm = {
    inspectionType: EInspectionType.HOME,
    make: { nameEn: '', nameAr: '', id: '', image: '', inShoppingList: true },
    model: { nameEn: '', nameAr: '', id: '', inShoppingList: true },
    year: { year: '', inShoppingList: true },
    kilometers: { value: 0, displayed: '', inShoppingList: true },
    transmission: { transmission: '', inShoppingList: true, id: '' },
    trafficPoint: { trafficPoint: '', inShoppingList: true, id: '' },
    region: {
        id: '',
        bigArea: '',
        smallArea: '',
        name: '',
        bigAreaAr: '',
        smallAreaAr: '',
        address: '',
        coordinate: null,
        polygon: [],
        warehouse: false,
        serviceable: false,
        addressCity: '',
        sendPinLocation: false,
    },
    contactInfo: { name: '', phone: '', email: '' },
};

const STEPPER_STEPS_FULL_DATA_MOBILE: IStepperIntializer[] = [
    {
        label: 'inspectionType',
        pathOneOnly: false,
        icon: LensGreenIcon.src,
    },
    {
        label: 'make',
        pathOneOnly: false,
        icon: MakeIconGreen.src,
    },
    {
        label: 'model',
        pathOneOnly: false,
        icon: ModelIconGreen.src,
    },
    {
        label: 'year',
        pathOneOnly: false,
        icon: CalendarIconGreen.src,
    },
    {
        label: 'kilometers',
        pathOneOnly: false,
        icon: KMIconGreen.src,
    },
    {
        label: 'otherinfo',
        pathOneOnly: false,
        icon: otherInfoIcon.src,
    },
    {
        label: 'region',
        pathOneOnly: true,
        icon: LocationIconGreen.src,
    },
    {
        label: 'contactInfo',
        pathOneOnly: false,
        icon: ContactIconGreen.src,
    },
];
const STEPPER_STEPS_FULL_DATA_MOBILE_VARIOATION: IStepperIntializer[] = [
    {
        label: 'make',
        pathOneOnly: false,
        icon: MakeIconGreen.src,
    },
    {
        label: 'model',
        pathOneOnly: false,
        icon: ModelIconGreen.src,
    },
    {
        label: 'year',
        pathOneOnly: false,
        icon: CalendarIconGreen.src,
    },
    {
        label: 'kilometers',
        pathOneOnly: false,
        icon: KMIconGreen.src,
    },
    {
        label: 'otherinfo',
        pathOneOnly: false,
        icon: otherInfoIcon.src,
    },
    {
        label: 'region',
        pathOneOnly: true,
        icon: LocationIconGreen.src,
    },
    {
        label: 'contactInfo',
        pathOneOnly: false,
        icon: ContactIconGreen.src,
    },
];

const SELL_CAR_FORM_DATA_FULL_MOBILE_VARIATION: ISellCarForm = {
    inspectionType: EInspectionType.HOME,
    make: { nameEn: '', nameAr: '', id: '', image: '', inShoppingList: true },
    model: { nameEn: '', nameAr: '', id: '', inShoppingList: true },
    year: { year: '', inShoppingList: true },
    kilometers: { value: 0, displayed: '', inShoppingList: true },
    transmission: { transmission: '', inShoppingList: true, id: '' },
    trafficPoint: { trafficPoint: '', inShoppingList: true, id: '' },
    region: {
        id: '',
        bigArea: '',
        smallArea: '',
        name: '',
        bigAreaAr: '',
        smallAreaAr: '',
        address: '',
        coordinate: null,
        polygon: [],
        warehouse: false,
        serviceable: false,
        addressCity: '',
        sendPinLocation: false,
    },
    contactInfo: { name: '', phone: '', email: '' },
};
const SELL_CAR_FORM_DATA_FULL_MOBILE: ISellCarForm = {
    inspectionType: EInspectionType.HOME,
    make: { nameEn: '', nameAr: '', id: '', image: '', inShoppingList: true },
    model: { nameEn: '', nameAr: '', id: '', inShoppingList: true },
    year: { year: '', inShoppingList: true },
    kilometers: { value: 0, displayed: '', inShoppingList: true },
    transmission: { transmission: '', inShoppingList: true, id: '' },
    trafficPoint: { trafficPoint: '', inShoppingList: true, id: '' },
    region: {
        id: '',
        bigArea: '',
        smallArea: '',
        name: '',
        bigAreaAr: '',
        smallAreaAr: '',
        address: '',
        coordinate: null,
        polygon: [],
        warehouse: false,
        serviceable: false,
        addressCity: '',
        sendPinLocation: false,
    },
    contactInfo: { name: '', phone: '', email: '' },
};
const SELL_CAR_FORM_DATA_FULL_WAREHOUSE_VARIANT: ISellCarForm = {
    inspectionType: EInspectionType.WAREHOUSE,
    make: { nameEn: '', nameAr: '', id: '', image: '', inShoppingList: true },
    model: { nameEn: '', nameAr: '', id: '', inShoppingList: true },
    year: { year: '', inShoppingList: true },
    kilometers: { value: 0, displayed: '', inShoppingList: true },
    transmission: { transmission: '', inShoppingList: true, id: '' },
    trafficPoint: { trafficPoint: '', inShoppingList: true, id: '' },
    region: {
        id: '',
        bigArea: '',
        smallArea: '',
        name: '',
        bigAreaAr: '',
        smallAreaAr: '',
        address: '',
        coordinate: null,
        polygon: [],
        warehouse: false,
        serviceable: false,
        addressCity: '',
        sendPinLocation: false,
    },
    contactInfo: { name: '', phone: '', email: '' },
};
const SELL_CAR_FORM_DATA_FULL_HOME_VARIANT: ISellCarForm = {
    inspectionType: EInspectionType.HOME,
    make: { nameEn: '', nameAr: '', id: '', image: '', inShoppingList: true },
    model: { nameEn: '', nameAr: '', id: '', inShoppingList: true },
    year: { year: '', inShoppingList: true },
    kilometers: { value: 0, displayed: '', inShoppingList: true },
    transmission: { transmission: '', inShoppingList: true, id: '' },
    trafficPoint: { trafficPoint: '', inShoppingList: true, id: '' },
    region: {
        id: '',
        bigArea: '',
        smallArea: '',
        name: '',
        bigAreaAr: '',
        smallAreaAr: '',
        address: '',
        coordinate: null,
        polygon: [],
        warehouse: false,
        serviceable: false,
        addressCity: '',
        sendPinLocation: false,
    },
    contactInfo: { name: '', phone: '', email: '' },
};
const STEPPER_STEPS_FULL_DATA_DESKTOP_WAREHOUSE_VARIANT: IStepperIntializer[] =
    [
        {
            label: 'inspectionType',
            pathOneOnly: false,
            icon: LensGreenIcon.src,
            allowed: true,
        },
        {
            label: 'make',
            pathOneOnly: false,
            icon: MakeIconGreen.src,
        },
        {
            label: 'model',
            pathOneOnly: false,
            icon: ModelIconGreen.src,
        },
        {
            label: 'year',
            pathOneOnly: false,
            icon: CalendarIconGreen.src,
        },
        {
            label: 'kilometers',
            pathOneOnly: false,
            icon: KMIconGreen.src,
        },
        {
            label: 'otherinfo',
            pathOneOnly: false,
            icon: otherInfoIcon.src,
        },
        {
            label: 'region',
            pathOneOnly: true,
            icon: LocationIconGreen.src,
            manuallyDisabled: true,
            allowed: false,
        },
        {
            label: 'contactInfo',
            pathOneOnly: false,
            icon: ContactIconGreen.src,
        },
    ];
const STEPPER_STEPS_FULL_DATA_DESKTOP_HOME_VARIANT: IStepperIntializer[] = [
    {
        label: 'inspectionType',
        pathOneOnly: false,
        icon: LensGreenIcon.src,
        allowed: true,
    },
    {
        label: 'make',
        pathOneOnly: false,
        icon: MakeIconGreen.src,
    },
    {
        label: 'model',
        pathOneOnly: false,
        icon: ModelIconGreen.src,
    },
    {
        label: 'year',
        pathOneOnly: false,
        icon: CalendarIconGreen.src,
    },
    {
        label: 'kilometers',
        pathOneOnly: false,
        icon: KMIconGreen.src,
    },
    {
        label: 'otherinfo',
        pathOneOnly: false,
        icon: otherInfoIcon.src,
    },
    {
        label: 'region',
        pathOneOnly: true,
        icon: LocationIconGreen.src,
    },
    {
        label: 'contactInfo',
        pathOneOnly: false,
        icon: ContactIconGreen.src,
    },
];

export {
    STEPPER_STEPS_FULL_DATA,
    SELL_CAR_FORM_DATA_FULL,
    STEPPER_STEPS_FULL_DATA_MOBILE,
    SELL_CAR_FORM_DATA_FULL_MOBILE,
    STEPPER_STEPS_FULL_DATA_MOBILE_VARIOATION,
    SELL_CAR_FORM_DATA_FULL_MOBILE_VARIATION,
    STEPPER_STEPS_FULL_DATA_DESKTOP_WAREHOUSE_VARIANT,
    SELL_CAR_FORM_DATA_FULL_WAREHOUSE_VARIANT,
    SELL_CAR_FORM_DATA_FULL_HOME_VARIANT,
    STEPPER_STEPS_FULL_DATA_DESKTOP_HOME_VARIANT,
};
